import { Settings } from './types';

export const APP_SETTINGS: Settings = {
  layout: '',
  container: 'fixed',
  layouts: {
    demo7: {
      headerSticky: true,
      headerStickyOffset: 200,
    },
  },
};
